import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Form, Modal } from 'antd';
import type React from 'react';
import type { AnalysisStationCreateInput } from '../../../../graphql/generated/graphql';
import type { AnalysisStation } from '../AnalysisStations';
import { AnalysisStationForm } from './AnalysisStationForm';
import { CREATE_ANALYSIS_STATION_MUTATION } from './CreateAnalysisStationModal.gql';

interface CreateAnalysisStationModalProps {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
  labId: string;
  analysisStations: AnalysisStation[];
}

export const CreateAnalysisStationModal: React.FC<CreateAnalysisStationModalProps> = ({
  open,
  onSuccess,
  onClose,
  labId,
  analysisStations,
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [createAnalysisStationMutation, { loading }] = useMutation(CREATE_ANALYSIS_STATION_MUTATION);

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  const nameValidator = (name: string) => {
    return analysisStations.length === 0 || !analysisStations.some(it => it.name.toLowerCase() === name.toLowerCase());
  };

  const create = async (values: AnalysisStationCreateInput) => {
    try {
      await createAnalysisStationMutation({
        variables: {
          input: {
            labId: labId,
            name: values.name,
            description: values.description || '',
          },
        },
      });
      message.success('Analysestation wurde erstellt');
      onSuccess();
      closeAndReset();
    } catch (_e) {
      message.error('Analysestation konnte nicht erstellt werden');
    }
  };

  return (
    <Modal
      title="Neue Analysestation"
      open={open}
      onOk={form.submit}
      onCancel={closeAndReset}
      confirmLoading={loading}
      width={768}
      destroyOnHidden
      okText="Erstellen"
      cancelText="Abbrechen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
    >
      <AnalysisStationForm
        form={form}
        initialValues={{ labId, name: '', description: '' }}
        onFinish={values => create(values as AnalysisStationCreateInput)}
        nameValidator={nameValidator}
      />
    </Modal>
  );
};
